<template>
	<div>
		<div v-if="!dateOnly_prop"	class="col-auto mb-2 pl-0 d-inline-block text-left">
			<form class="form-inline">
			  <div class="form-group">
			    <label for="dateRange" class="sr-only">Report Type</label>
			    <input type="text" disabled class="form-control-plaintext py-0" id="reportTypeClient" style="width: 109px;" value="Report Type">
			  </div>

				<select class="custom-select py-0 pl-2 pr-0" style="height: 33px; width: 80px; background-color: transparent; border-color:  rgb(43, 53, 83); font-size: 13px;" v-model="reportType">
				  <option value="all" style="background-color: #1a1e34;">ALL</option>
				  <option value="day" style="background-color: #1a1e34;">DAILY</option>
				  <option value="week" style="background-color: #1a1e34;">WEEKLY</option>
				  <option value="month" style="background-color: #1a1e34;">MONTHLY</option>
				  <option value="year" style="background-color: #1a1e34;">YEARLY</option>
				</select>
			</form>
		</div>

		<div v-if="reportType != 'all'" class="col-auto mb-2 pl-0 d-inline-block">
			<form class="form-inline">
			  <div class="form-group">
			    <label for="dateRange" class="sr-only">Date Range</label>
			    <input v-if="!dateOnly_prop" type="text" disabled class="form-control-plaintext py-0" id="reportPeriodClient" style="width: 120px;" value="Report Period">
			    <input v-else type="text" disabled class="form-control-plaintext py-0" id="reportPeriodClient" style="width: 120px;" value="Date Range">
			  </div>

			  <template v-if="reportType == 'day'">
					<div class="form-group mr-2">
						<label for="filterStartDateClient" class="sr-only">Start Date</label>
						<input type="date" class="form-control py-0" id="filterStartDateClient" style="height: 33px;" min="2020-01-01" :max="endDateDay" v-model="startDateDayInInput">
					</div>

					<div class="form-group">
						<label for="filterEndDateDayClient" class="sr-only">End Date</label>
						<input type="date" class="form-control py-0" id="filterEndDateDayClient" style="height: 33px;" :min="startDateDayInInput" :max="dateToday" v-model="endDateDay">
					</div>
				</template>

				<template v-if="reportType == 'week'">
					<input list="weeklyDateListClient" name="location" id="startDateWeek" class="form-control" style="height: 33px;" v-model.lazy="startDateWeekInInput" onfocus="this.value=''" onchange="this.blur();" required>
					<datalist id="weeklyDateListClient">
						<option v-for="item in weeklyDateList " :key="`${item}Week`" :value="item"></option>
					</datalist>

					<div class="form-group ml-2">
						<label for="filterEndDateWeekClient" class="sr-only">End Date</label>
						<input type="date" class="form-control c-disabled py-0" id="filterEndDateWeekClient" style="height: 33px;" v-model="endDateWeek" disabled>
					</div>
				</template>

				<template v-if="reportType == 'month'">
					<input list="monthlyDateListClient" name="location" id="startDateMonth" class="form-control" style="height: 33px;" v-model.lazy="startDateMonthInInput" onfocus="this.value=''" onchange="this.blur();" required>
					<datalist id="monthlyDateListClient">
						<option v-for="item in monthlyDateList " :key="`${item}Month`" :value="item"></option>
					</datalist>
					
					<div class="form-group ml-2">
						<label for="filterEndDateMonthClient" class="sr-only">End Date</label>
						<input type="date" class="form-control c-disabled py-0" id="filterEndDateMonthClient" style="height: 33px;" v-model="endDateMonth" disabled>
					</div>
				</template>

				<template v-if="reportType == 'year'">
					<input list="yearlyDateListClient" name="location" id="startDateYear" class="form-control" style="height: 33px;" v-model.lazy="startDateYearInInput" onfocus="this.value=''" onchange="this.blur();" required>
					<datalist id="yearlyDateListClient">
						<option v-for="item in yearlyDateList " :key="`${item}Year`" :value="item"></option>
					</datalist>

					<div class="form-group ml-2">
						<label for="filterEndDateYearClient" class="sr-only">End Date</label>
						<input type="date" class="form-control c-disabled py-0" id="filterEndDateYearClient" style="height: 33px;" v-model="endDateYear" disabled>
					</div>
				</template>

			</form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'FIlterDateAndType',

		props: {
			filterId: {
				type: String,
				default: String(Math.random())
			},

			dateOnly_prop: {
				type: Boolean,
				default: false
			}
		},

		data() {
			const today = new Date(Date.now())
			let todayDay = today.getDay()
			let tempDay = new Date(Date.now())
			let tempWeek = new Date(Date.now())
			let tempMonth = new Date(Date.now())
			let tempYear = new Date(Date.now())
			return {
				reportType: 'all',
				reportMonth: 'january',
				reportYear: '2019',

				dateToday: `${tempDay.getFullYear()}-${tempDay.getMonth() + 1 < 10 ? '0' : ''}${tempDay.getMonth() + 1}-${tempDay.getDate()< 10 ? '0' : ''}${tempDay.getDate()}`,

				startDateDay: new Date(tempDay.setDate(tempDay.getDate() - 1)),
				// startDateDay: '',
				endDateDay: `${tempDay.getFullYear()}-${tempDay.getMonth() + 1 < 10 ? '0' : ''}${tempDay.getMonth() + 1}-${tempDay.getDate() + 1 < 10 ? '0' : ''}${tempDay.getDate() + 1}`,
				// endDate: '',

				startDateWeek: new Date(tempWeek.setDate(tempWeek.getDate() - todayDay + 1)),
				weeklyDateList: [],

				startDateMonth: new Date(tempMonth.setDate(1)),
				monthlyDateList: [],

				startDateYear: new Date(new Date(tempYear.setDate(1)).setMonth(0)),
				yearlyDateList: [],

				showReportType: true,
			}
		},

		computed: {
			startDateDayInInput: {
				get: function() {
					let temp = this.startDateDay
					if (temp) {
						return `${temp.getFullYear()}-${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}-${temp.getDate() < 10 ? '0' : ''}${temp.getDate()}`
					}else {
						return ''
					}
				},
				set: function(newValue) {
					this.startDateDay = new Date(newValue)
				}
			},

			startDateWeekInInput: {
				get: function() {
					let temp = this.startDateWeek
					if (temp) {
						return `${temp.getDate() < 10 ? '0' : ''}${temp.getDate()}/${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}/${temp.getFullYear()}`
					}else {
						return ''
					}
				},
				set: function(newValue) {
					let temp = new Date(`${newValue.substr(6, 4)}-${newValue.substr(3, 2)}-${newValue.substr(0, 2)}`)
					this.startDateWeek = temp
				}
			},
			endDateWeek() {
				let temp = this.startDateWeek
				if (temp) {
					return `${temp.getFullYear()}-${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}-${temp.getDate() + 4 < 10 ? '0' : ''}${temp.getDate() + 4}`
				}else {
					return ''
				}
			},

			startDateMonthInInput: {
				get: function() {
					let temp = this.startDateMonth
					if (temp) {
						return `01/${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}/${temp.getFullYear()}`
					}else {
						return ''
					}
				},
				set: function(newValue) {
					let temp = new Date(`${newValue.substr(6, 4)}-${newValue.substr(3, 2)}-${newValue.substr(0, 2)}`)
					this.startDateMonth = temp
				}
			},
			endDateMonth() {
				let temp = this.startDateMonth
				if (temp) {
					temp.setMonth(temp.getMonth() + 1)
					temp.setDate(temp.getDate() - 1)
					return `${temp.getFullYear()}-${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}-${temp.getDate() < 10 ? '0' : ''}${temp.getDate()}`
				}else {
					return ''
				}
			},

			startDateYearInInput: {
				get: function() {
					let temp = this.startDateYear
					if (temp) {
						return `01/01/${temp.getFullYear()}`
					}else {
						return ''
					}
				},
				set: function(newValue) {
					if (newValue) {
						let temp = new Date(`${newValue.substr(6, 4)}-${newValue.substr(3, 2)}-${newValue.substr(0, 2)}`)
						this.startDateYear = temp
					}
				}
			},
			endDateYear() {
				let temp = this.startDateYear
				if (temp) {
					temp.setFullYear(temp.getFullYear() + 1)
					temp.setDate(temp.getDate() - 1)
					return `${temp.getFullYear()}-${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}-${temp.getDate() < 10 ? '0' : ''}${temp.getDate()}`
				}else {
					return ''
				}
			},

			watcherChangeFilter() {
				return `${this.reportType}${this.startDateDay}${this.startDateWeek}${this.startDateMonth}${this.startDateYear}${this.endDateDay}`
			},
		},

		watch: {
			watcherChangeFilter() {
				this.changeFilterDateAndType()
			},

			reportType(newValue) {
				if (newValue == 'week') {
					if (this.weeklyDateList.length < 1) {

						let todayDate = new Date(Date.now())
						let todayDay = todayDate.getDay()
						let nearestMondayDate = new Date(todayDate.setDate(todayDate.getDate() - todayDay + 1))

						while (nearestMondayDate.getFullYear() >= 2020) {
							this.weeklyDateList.push(`${nearestMondayDate.getDate() < 10 ? '0' : ''}${nearestMondayDate.getDate()}/${nearestMondayDate.getMonth() + 1 < 10 ? '0' : ''}${nearestMondayDate.getMonth() + 1}/${nearestMondayDate.getFullYear()}`)
							nearestMondayDate = new Date(nearestMondayDate.setDate(nearestMondayDate.getDate() - 7))
						}

					}
				}else if (newValue == 'month') {
					if (this.monthlyDateList.length < 1) {

						let todayDate = new Date(Date.now())
						let todayMonth = todayDate.getMonth() // 0 = January
						let monthDate = new Date(todayDate.getFullYear() + '-' + (todayMonth + 1 < 10 ? '0' : '') + String(todayMonth + 1) + '-01')

						while (monthDate.getFullYear() >= 2020) {
							this.monthlyDateList.push(`01/${monthDate.getMonth() + 1 < 10 ? '0' : ''}${monthDate.getMonth() + 1}/${monthDate.getFullYear()}`)
							monthDate =  new Date(monthDate.setMonth(monthDate.getMonth() - 1))
						}

					}
				}else {
					if (this.yearlyDateList.length < 1) {

						let todayDate = new Date(Date.now())
						let yearDate = new Date(todayDate.getFullYear() + '-01-01')

						while (yearDate.getFullYear() >= 2020) {
							this.yearlyDateList.push(`01/01/${yearDate.getFullYear()}`)
							yearDate =  new Date(yearDate.setFullYear(yearDate.getFullYear() - 1))
						}
					
					}
				}
			},
		},

		created() {
			if (this.dateOnly_prop) {
				this.reportType = 'day'
				this.showReportType = false
				this.startDateDay = ''
				this.endDateDay = ''
			}
		},

		methods: {
			changeFilterDateAndType() {
				let startDate = this.startDateDay
				let endDate = this.endDateDay
				let tempStart
				let tempEnd

				if (this.reportType == 'all') {
					startDate = ''
					endDate = ''
				}else if (this.reportType == 'day') {
					startDate = this.startDateDay
				}else if (this.reportType == 'week') {
					startDate = this.startDateWeek
					endDate = ''
				}else if (this.reportType == 'month') {
					startDate = this.startDateMonth
					endDate = ''
				}else {
					startDate = this.startDateYear
					endDate = ''
				}

				if (startDate) {
					tempStart = `${startDate.getFullYear()}-${startDate.getMonth() + 1 < 10 ? '0' : ''}${startDate.getMonth() + 1}-${startDate.getDate() < 10 ? '0' : ''}${startDate.getDate()}`
					startDate = new Date(tempStart)

					if (this.reportType == 'day' && endDate == '') {
						this.endDateDay = tempStart
						endDate = startDate
					}
				}
				if (endDate) {
					tempEnd = endDate
					endDate = new Date(endDate)

					if (this.reportType == 'day' && startDate == '') {
						this.startDateDayInInput = tempEnd
						startDate = endDate
					}
				}

				let temp = {
					type: this.reportType,
					startDate: startDate, 
					endDate: endDate
				}
				this.$emit('changeFilterDateAndType', temp)
			}
		}
	}
</script>